/* eslint-disable confluence-feature-gating/inline-usage */
/* eslint-disable confluence-feature-gating/inline-expVal-params */
import React, { Fragment } from 'react';

import { fg } from '@confluence/feature-gating';
import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';
// This component will purposefully introduce a regression into the page

/**
 *
 * This component will purposefully introduce a regression into the page
 *
 * controlled by the feature gate confluence_artificial_regression
 * For every point of severity, we will introduce a slowdown of the page by the severity points * 100ms
 *
 * @param routeName - the name of the route to introduce the regression to
 * @param children - the children to render
 * @returns the children wrapped in a div with a data-testid and id
 */
export const ArtificialRegressionComponent = ({ children }: { children: React.ReactNode }) => {
	if (!fg('confluence_artificial_regression')) {
		return <Fragment>{children}</Fragment>;
	}

	// Add a small CPU block based on severity to create visible jank
	let waste = 0;
	const timeStart = performance.now();
	// 500ms is a magic number that we use to create a visible regression
	const duration = StatsigConfigurations.getNumber('confluence_artificial_regression_ms', 500);
	while (performance.now() < timeStart + duration) {
		waste += Math.sqrt(waste + 1);
	}
	void waste;

	return (
		<div
			id={`artificial-rerender-regression-component-regressed-by-${duration}ms`}
			data-testid="artificial-rerender-regression-component"
		>
			{children}
		</div>
	);
};
